import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { loginAsync } from "@application/features/auth/authThunk";
import LocalStorageService from "@application/features/Common/local-storage-service";
import { useAppDispatch } from "@application/store/useStore";
import { useMsal } from "@azure/msal-react";
import { Box, Typography, useTheme } from "@mui/material";
import { PButton } from "@ui/components/buttons/PButton";
import { centered } from "@ui/style/style";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginRequest } from "../../../../auth-config";
import { useTranslation } from "react-i18next";
export const AdminLogin = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { instance } = useMsal();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [isLoggingIn, setIsLoggingIn] = useState(false);
    const loginText = isLoggingIn
        ? t("admin.login.signingIn")
        : t("admin.login.signIn");
    useEffect(() => {
        setIsLoggingIn(true);
        if (!instance)
            return;
        instance
            .initialize() // Ensure the instance is initialized
            .then(() => instance.handleRedirectPromise())
            .then((response) => {
            if (response) {
                const { account, accessToken } = response;
                LocalStorageService.setMSAccessToken(accessToken);
                instance.setActiveAccount(account);
                dispatch(loginAsync())
                    .unwrap()
                    .then(() => navigate("/admin/invitation"))
                    .catch((error) => { })
                    .finally(() => setIsLoggingIn(false));
            }
            else {
                setIsLoggingIn(false);
            }
        })
            .catch((error) => {
            setIsLoggingIn(false);
        });
    }, [instance, dispatch, navigate]);
    const loginMsl = async () => {
        if (isLoggingIn)
            return;
        setIsLoggingIn(true);
        try {
            await instance.loginRedirect(loginRequest);
        }
        catch (error) {
            setIsLoggingIn(false);
        }
    };
    return (_jsxs(Box, { sx: {
            ...centered,
            height: "100dvh",
            width: "100%",
            backgroundImage: `url('/assets/images/background.png')`,
            backgroundSize: "cover",
            backgroundPosition: "top 10%",
            backgroundRepeat: "no-repeat",
            flexDirection: "column",
            justifyContent: "center",
            backgroundColor: "#F4FBFF",
            overflow: "hidden",
        }, children: [_jsx(Box, { component: "img", sx: {
                    height: "auto",
                    width: "clamp(250px, 40vh, 400px)",
                }, src: "/assets/images/Sky-speaker.png" }), _jsxs(Box, { sx: {
                    maxWidth: 496,
                    maxHeight: 559,
                    padding: { xs: 5, sm: "28px 112px" },
                    boxShadow: "0px 12px 24px -4px rgba(145, 158, 171, 0.12), 0px 0px 2px 0px rgba(145, 158, 171, 0.2)",
                    backdropFilter: "blur(20px)",
                    borderRadius: 6,
                    background: "#FFFFFFCC",
                    gap: 'clamp(2.5rem, 0rem + 5.556vw, 5rem)',
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                }, children: [_jsxs(Box, { display: "flex", flexDirection: "column", sx: {
                            gap: "clamp(1rem, -0.25rem + 2.778vw, 2.25rem)",
                        }, alignItems: "center", children: [_jsx(Typography, { variant: "h4", color: "text.primary", sx: {
                                    width: 260,
                                    fontSize: "clamp(42px, 5vw, 42px) !important",
                                    textAlign: "center",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    fontFamily: "PowerGrotesk",
                                }, children: t("admin.login.title") }), _jsx("img", { src: "/assets/images/logo.svg", alt: "logo", height: "auto", style: {
                                    width: "clamp(150px, 25vh, 260px)",
                                } })] }), _jsx(PButton, { size: "xl", startIcon: _jsx("img", { src: "https://img.icons8.com/color/48/000000/microsoft.png", alt: "Microsoft logo", style: { height: 24 } }), minWidth: 260, onClick: loginMsl, children: _jsx(Typography, { variant: "h6", sx: { whiteSpace: "nowrap", fontFamily: "PowerGrotesk" }, children: loginText }) })] })] }));
};
